<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix"></div>
    <div class="text">
      <div class="mt">
        <p style="font-weight: 400; padding-bottom: 20px">
          依<span style="font-weight: 700">{{ userName }}</span
          >的申请，经查询，查档编号: <span style="font-weight: 700">{{ resultNumber }}</span>
        </p>
        <p>
          <span>因多人查询耗费时间，查询提交后,可在</span
          ><router-link to="/home/userCenter">我的中心</router-link>-我的查询中下载查询结果
        </p>
      </div>
      <div class="jzxx">
        <el-button class="mt30" type="default" @click="backHomepage" size="small">返回大厅</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { localDataUser } from '@iebdc/utils/local-data';
export default {
  name: '',
  components: {},
  props: {
    resultNumber: {
      type: String,
    },
  },
  data() {
    return {
      userName: localDataUser.get().name,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    backHomepage() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.mt {
  font-size: 18px;
  text-align: center;
  margin: 30px 0 30px 0;
  font-weight: 700;
  a {
    color: #0099ff;
  }
}

.jzxx {
  text-align: center;
}
</style>
